import cn from 'classnames';
import { FC } from 'react';

import { useAppSelector, useMedia } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { toolbarMIRModel } from '@/entities/toolbarMIR';

import { MaskEditActions } from '@/features/maskEdit';
import { TeethEditActions } from '@/features/toothNumberEdit';

import { TopBarBlock } from '../../config';
import { useTopBarBlockTransition } from '../../hooks';
import { MaskFilters } from '../MaskFilters/MaskFilters';

import styles from './MaskFiltersWrapper.module.scss';

type MaskFiltersWrapperProps = {
  className?: string;
  testID?: string;
};

const getTargetBlock = (params: {
  isEditingMask: boolean;
  isEditingTeeth: boolean;
}): TopBarBlock => {
  const { isEditingMask, isEditingTeeth } = params;

  if (isEditingMask) {
    return 'maskActions';
  }

  if (isEditingTeeth) {
    return 'teethActions';
  }

  return 'filters';
};

export const MaskFiltersWrapper: FC<MaskFiltersWrapperProps> = (props) => {
  const { className, testID } = props;

  const { isMobile } = useMedia();

  const isEditingMask = useAppSelector(
    toolbarMIRModel.selectors.selectIsEditingMask('main'),
  );
  const isEditingTeeth = useAppSelector(
    toolbarMIRModel.selectors.selectIsEditingTeeth('main'),
  );
  const isFullscreen = useAppSelector(
    toolbarMIRModel.selectors.selectToolbarProperty('main', 'expand'),
  );
  const { masksVisible } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const { isHiding, visibleBlock } = useTopBarBlockTransition(
    getTargetBlock({ isEditingMask, isEditingTeeth }),
  );

  if (isMobile && !isFullscreen) {
    return null;
  }

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="mask-filters-wrapper"
    >
      {visibleBlock === 'filters' && masksVisible && (
        <div className={cn(styles.filtersWrapper, isHiding && styles.hiding)}>
          <MaskFilters />
        </div>
      )}
      {visibleBlock === 'maskActions' && (
        <MaskEditActions isHiding={isHiding} />
      )}
      {visibleBlock === 'teethActions' && (
        <TeethEditActions isHiding={isHiding} />
      )}
    </div>
  );
};
